<template>
  <div v-if="user">
    <user-details :data-user.sync="user" @update:dataUser="updateUser" @syncOffer="syncOffer" />
    <user-allocation class="mt-2" :user-allocation="user.allocation" :user-id="user.id" />
    <business-relation
      class="mt-2"
      :user-id="user.id"
      v-if="hasManageBusinessRelationCommentPermission"
    />
    <asset-freeze :user.sync="user" class="mt-2" @update:user="updateUser" />
    <update-reason :data.sync="user.history" class="mt-2" />
    <user-documents :user.sync="user" class="mt-2" />
    <individual-mobile-money-details class="mt-2" :owner="user" v-if="user.is_individual" />
    <individual-bank-details class="mt-2" :owner="user" v-if="user.is_individual" />
    <user-currency-limits :user-id="user.id" class="mt-2" />
    <!-- <user-transactions :id="id"></user-transactions> -->
  </div>
</template>
<script>
import UserDetails from "./detail";
import UserDocuments from "./documents";
// import UserTransactions from "./transactions";
import UserCurrencyLimits from "@/app/crypto/limits";
import UpdateReason from "@/app/updateReason/show";
import IndividualBankDetails from "@/app/accounts/bankaccounts/all.vue";
import IndividualMobileMoneyDetails from "@/app/accounts/mobilemoney/all.vue";
import AssetFreeze from "./assetFreeze.vue";
import BusinessRelation from "./businessRelation";
import UserAllocation from "./userAllocation.vue";

export default {
  components: {
    IndividualBankDetails,
    IndividualMobileMoneyDetails,
    UserDetails,
    UserDocuments,
    // UserTransactions,
    UserCurrencyLimits,
    UpdateReason,
    AssetFreeze,
    BusinessRelation,
    UserAllocation,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    user: null,
  }),
  mounted() {
    this.fetchData();
  },
  methods: {
    syncOffer() {
      this.fetchData();
    },
    async fetchData() {
      await this.$http.get(`/api/v1/users/${this.id}`).then((user) => (this.user = user));
    },
    updateUser(user) {
      if (user) {
        this.user = user;
      }
      this.fetchData();
    },
  },
  computed: {
    hasManageBusinessRelationCommentPermission() {
      return this.$globalStore.user.roles.some((role) =>
        role.permissions.some(
          (perm) => perm.slug === "Users\\Models\\BusinessRelationComment::manage",
        ),
      );
    },
  },
};
</script>
